export const tagManagerEvents = () => {

  window.dataLayer = window.dataLayer || []

  document.addEventListener('click', function (event) {

    const target = event.target;

    const events = [
      'open',
      'next',
      'prev',
      'cancel'
    ]

    events.forEach(function (event) {
      if (target.matches('[data-diagnostic-' + event + ']')) {

        window.dataLayer.push({
          'event': 'tv troubleshooting tool',
          'eventStage': target.getAttribute('data-diagnostic-' + event),
          'previousStep': event === 'prev',
          'cancelStep': event === 'cancel'
        });
      }
    });

  });

}
